module.exports = __webpack_public_path__ + "static/img/skin.8ee68ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/skin/3/skin.png
// module id = 5xpL
// module chunks = 2